var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "LegendButtonOff",

    getDefaultProps () {
        return {"width":"48px","height":"48px","viewBox":"0 0 48 48","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>legend_button_off</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="legend_button_off" fill="#034C8C">
      <path d="M0,24 C0,10.745166 10.7422516,0 24,0 C37.254834,0 48,10.7422516 48,24 C48,37.254834 37.2577484,48 24,48 C10.745166,48 0,37.2577484 0,24 Z M15,30.4666667 L15,33 L33,33 L33,30.4666667 L15,30.4666667 Z M20.7857143,25.1466667 L27.2142857,25.1466667 L28.3714286,27.9333333 L31.0714286,27.9333333 L24.9642857,14 L23.0357143,14 L16.9285714,27.9333333 L19.6285714,27.9333333 L20.7857143,25.1466667 Z M24,16.508 L26.4042857,22.8666667 L21.5957143,22.8666667 L24,16.508 Z" id="Combined-Shape"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/images/legend_button_off.svg